export const EnvName = {
    Local: "local-development",
    Development: "development-new",
    Staging: "staging-new",
    Production: "production-new",
};
